import React from 'react';
import { Box, Typography, Paper, IconButton, Icon, Tooltip } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { marked } from 'marked';

const StoryCard = ({ title, structure, chapters, analysis, highlightedContent, modelName }) => {
    const renderMarkdown = (markdownText) => {
        return { __html: marked(markdownText) };
    };

    return (
        <Box>
            <Typography variant="h6" gutterBottom>{title}</Typography>
            {chapters.map((chapter, index) => (
                <Box key={index} sx={{ marginBottom: 2 }}>
                    <Typography variant="subtitle2">{chapter.title}</Typography>
                    {chapter.content.map((paragraph, pIndex) => (
                        <Typography
                            key={pIndex}
                            dangerouslySetInnerHTML={{ __html: highlightedContent ? highlightedContent[index][pIndex] : paragraph }}
                            sx={{ marginBottom: 1 }}
                        />
                    ))}
                </Box>
            ))}

            {analysis && (
                <Paper sx={{ padding: 2, marginTop: 2, backgroundColor: '#f9f9f9' }}>
                    <Typography variant="h6" gutterBottom>Gender Bias Analysis</Typography>
                    <Box display="flex" alignItems="center">
                        <Typography variant="body1">
                            <strong>GenBit Score:</strong> {analysis.bias?.genbit_score?.toFixed(4) || 'N/A'}
                        </Typography>
                        <Tooltip title="Learn more about GenBit Score">
                            <IconButton
                                size="small"
                                href="https://github.com/microsoft/responsible-ai-toolbox-genbit"
                                target="_blank"
                                rel="noopener noreferrer"
                                sx={{ marginLeft: 1 }}
                            >
                                <HelpOutlineIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                    </Box>
                    <Typography variant="body1">
                        <strong>Protagonist Name:</strong> {analysis.protagonist_name || 'N/A'}
                    </Typography>
                    <Typography variant="body1">
                        <strong>Protagonist Gender:</strong> {analysis.protagonist_gender || 'N/A'}
                    </Typography>
                </Paper>
            )}

            {analysis && (
                <Paper sx={{ padding: 2, marginTop: 2, backgroundColor: '#f9f9f9' }}>
                    <Typography variant="h6" gutterBottom>Classification Analysis</Typography>
                    <Typography variant="body1">
                        <strong>Original Structure:</strong> {structure}
                    </Typography>
                    <Typography variant="body1">
                        <strong>Classification by {modelName}:</strong> {analysis.classification || 'N/A'}
                    </Typography>
                    <Box display="flex" alignItems="center">
                        <Typography variant="body1">
                            <strong>Explanation by {modelName}:</strong>
                        </Typography>
                        <Tooltip title="The explanation was generated by the LLM. No post-processing or formatting modifications were applied; the content is presented in its original, unaltered form.">
                            <Icon
                                size="small"
                                sx={{ marginLeft: 1, marginTop: -1 }}
                            >
                                <HelpOutlineIcon fontSize="small" />
                            </Icon>
                        </Tooltip>
                    </Box>
                    <Typography
                        variant="body2"
                        sx={{ marginTop: 1, whiteSpace: 'pre-line' }}
                        dangerouslySetInnerHTML={renderMarkdown(analysis.explanation || 'N/A')}
                    />
                </Paper>
            )}
        </Box>
    );
};

export default StoryCard;
